// extracted by mini-css-extract-plugin
export default {"container":"WarehouseTransfers_container__rfDN2"};